// /app/frontend/src/lib/wagmi.js
// wagmi configuration for DenJouir. Browser-extension wallets ONLY —
// MetaMask, Coinbase Wallet, and any injected provider (Rabbit, Brave, etc.).
//
// WalletConnect was intentionally removed to eliminate the boot-time
// `explorer-api.walletconnect.com` + `pulse.walletconnect.org` chatter that
// caused intermittent "webpage not loading" reports on production. Since
// Emergent's hosting layer doesn't route blockchain UDP/TCP RPC cleanly
// through Cloudflare, keeping the WC connector meant those calls could
// hang at the edge and delay initial paint.
//
// Trade-off: mobile users can no longer "scan QR with any wallet app" —
// they must open the site inside their wallet's built-in browser
// (MetaMask, Coinbase, Rainbow, Trust all support this). Desktop users
// are unaffected.
import { createConfig, http } from "wagmi";
import { mainnet, base, polygon } from "wagmi/chains";
import { injected, coinbaseWallet, metaMask } from "wagmi/connectors";

export const wagmiConfig = createConfig({
  chains: [mainnet, base, polygon],
  connectors: [
    injected({ shimDisconnect: true }),
    metaMask(),
    coinbaseWallet({ appName: "DenJouir" }),
  ],
  transports: {
    [mainnet.id]: http(),
    [base.id]: http(),
    [polygon.id]: http(),
  },
  ssr: false,
});
